import type { ProductsBlock as ProductsBlockDoc, LayerProductCard } from '../types';

/**
 * Doporučené produkty (jen `kind='recommendation'`). Server posílá HOTOVÉ
 * karty — ceny jako řetězce, URL absolutní. Výloha s penězi nepočítá, jen
 * vykreslí. Když server nic nevrátil (anonym bez fallbacku), blok zmizí.
 */
export function ProductsBlock({ block }: { block: ProductsBlockDoc }) {
  const products = (block.resolved ?? []).slice(0, Math.max(1, block.count));
  if (products.length === 0) return null;

  return (
    <div className="layer-products" data-count={products.length}>
      {products.map((product) => (
        <RecoCard key={product.productId} product={product} />
      ))}
    </div>
  );
}

function RecoCard({ product }: { product: LayerProductCard }) {
  return (
    <a className="layer-product-card" href={product.url}>
      <span className="layer-product-thumb" aria-hidden="true">
        {product.imageUrl === null ? (
          <span className="layer-product-placeholder">{product.name.slice(0, 1)}</span>
        ) : (
          <img src={product.imageUrl} alt="" loading="lazy" decoding="async" />
        )}
        {product.discountPercent !== null && (
          <span className="layer-product-sale">−{product.discountPercent} %</span>
        )}
      </span>
      <span className="layer-product-body">
        {product.brand !== null && <span className="layer-product-brand">{product.brand}</span>}
        <strong className="layer-product-name">{product.name}</strong>
        <span className="layer-product-price">
          {product.compareAtText !== null && (
            <s className="layer-product-was">{product.compareAtText}</s>
          )}
          <span className={product.discountPercent !== null ? 'is-sale' : ''}>
            {product.priceText}
          </span>
        </span>
      </span>
    </a>
  );
}
